import { createApiSlice } from "@common";
import {
  CRUD_CONNECTION_TYPE,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addConnectionType",
    method: "post",
    url: CRUD_CONNECTION_TYPE,
    stateKey: "message",
  },
  {
    name: "getConnectionType",
    method: "get",
    url: CRUD_CONNECTION_TYPE,
    stateKey: "data",
  },
  {
    name: "updateConnectionType",
    method: "put",
    url: CRUD_CONNECTION_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteConnectionType",
    method: "delete",
    url: CRUD_CONNECTION_TYPE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "connectionType",
  apiConfig,
  customReducers,
);
const connectionTypeSlice = slice;
// Export the slice's reducer
export default connectionTypeSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addConnectionType,
  getConnectionType,
  updateConnectionType,
  deleteConnectionType,
} = thunks;

// Destructure and export actions
export const { rowSelect } =
  actions;
